<template>
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.24407 0.872872C5.64284 0.41241 6.35716 0.41241 6.75593 0.872872L9.76318 4.34535C10.3241 4.99299 9.864 6 9.00725 6H2.99275C2.136 6 1.67594 4.99299 2.23682 4.34535L5.24407 0.872872Z" fill="#D9D9DE" stroke="#D9D9DE"/>
    <path d="M6.75593 15.1271C6.35716 15.5876 5.64284 15.5876 5.24407 15.1271L2.23682 11.6547C1.67594 11.007 2.136 10 2.99275 10L9.00725 10C9.864 10 10.3241 11.007 9.76318 11.6547L6.75593 15.1271Z" fill="#D9D9DE" stroke="#D9D9DE"/>
  </svg>
</template>
